WiseMetering.Views.DegreeDayIndicator = Backbone.Marionette.ItemView.extend({
    template: 'templates/indicators/types/degree_day'
});
